import { useTranslation } from 'react-i18next';
import { useEffect, useState, useRef } from 'react';

export default function StatsBanner() {
  const { t } = useTranslation();
  const [counted, setCounted] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const stats = [
    { value: 500, suffix: '+', label: t('statsClients') },
    { value: 2000, suffix: '+', label: t('statsCases') },
    { value: 12, suffix: '年', label: t('statsYears') },
    { value: 80, suffix: '+', label: t('statsTeam') },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !counted) {
          setCounted(true);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [counted]);

  return (
    <section ref={ref} className="w-full py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-3xl md:text-5xl font-heading font-bold text-white mb-2">
                {counted ? (
                  <CountUp target={stat.value} suffix={stat.suffix} />
                ) : (
                  <span>0{stat.suffix}</span>
                )}
              </div>
              <div className="text-sm md:text-base text-white/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CountUp({ target, suffix }: { target: number; suffix: string }) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    let step = 0;
    const timer = setInterval(() => {
      step++;
      setCurrent(Math.min(Math.floor(increment * step), target));
      if (step >= steps) clearInterval(timer);
    }, duration / steps);
    return () => clearInterval(timer);
  }, [target]);

  return <span>{current}{suffix}</span>;
}